import { render, staticRenderFns } from "./Login_bak.vue?vue&type=template&id=f5d27802"
import script from "./Login_bak.vue?vue&type=script&lang=js"
export * from "./Login_bak.vue?vue&type=script&lang=js"
import style0 from "./Login_bak.vue?vue&type=style&index=0&id=f5d27802&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports